export class DateUtils {
  static format = (datetime: string): string => {
    const date = new Date(datetime);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    //const hours = date.getHours().toString().padStart(2, '0');
    //const minutes = date.getMinutes().toString().padStart(2, '0');
    //const seconds = date.getSeconds().toString().padStart(2, '0');
    //return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    return `${day}.${month}.${year}`;
  };
  static formatWithTime = (datetime: string): string => {
    const date = new Date(datetime);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
  };
  static isInThePast = (datetime: string): boolean => {
    const date = new Date(datetime);
    const now = new Date();
    return date < now;
  };
  static nextDayOf = (datetime: string): string => {
    const date = new Date(datetime);
    date.setDate(date.getDate() + 1);
    return date.toISOString();
  };
  static getPayoutBounds(reference: Date) {
    const year = reference.getFullYear();
    const month = reference.getMonth();
    const day = reference.getDate();

    let start: Date;
    let end: Date;

    if (day >= 28) {
      start = new Date(year, month, 28);
    } else {
      start = new Date(year, month - 1, 28);
    }

    if (day <= 27) {
      end = new Date(year, month, 27);
    } else {
      end = new Date(year, month + 1, 27);
    }

    return { start, end };
  };
  static daysBetween(start: string | Date, end?: string | Date | null): number | null {
    if (!start || !end) {
      return null;
    }

    const startDate = new Date(start);
    const endDate = new Date(end);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const diffMs = endDate.getTime() - startDate.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    return Math.max(0, Math.floor(diffDays));
  }
}
